import React, { MutableRefObject, useMemo } from 'react';
import { useState, useEffect } from 'react';
import Strapi from '../../services/strapi';
import Article from '../../interfaces/article';
import { makeStyles } from '@material-ui/core/styles';
import { XGrid, ColDef, CellParams } from '@material-ui/x-grid';
import qs from 'qs';
import { Button, Card, TextField, Select, MenuItem, Grid } from '@material-ui/core';
import settings from '../../settings';
import AuthorsSearch from '../../atoms/Authors/AuthorSearch';


const pageSize = 15;

enum PublishStatus {
	all,
	pubished,
	notpublished,
}

interface ArticleListProps {
	collection_name: string,
	action: (slug: Article) => React.ReactElement,
	params?: any,
	execpt_slug?: string[],
	update?: MutableRefObject<() => void>,
}

const useStyles = makeStyles((theme) => ({
	article_link: {
		textDecoration: "inherit",
		color: "inherit"
	},
	card: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		padding: theme.spacing(2),
		marginBottom: theme.spacing(2)
	},
	search: {
		display: 'flex',
		flex: 1
	},
	publish: {
		display: 'flex',
		flex: 1	
	},
	addUser: {
		display: 'flex',
		marginLeft: theme.spacing(2)
	},
  }));

const ArticleList = (props: ArticleListProps) => {
	const [articles, setArticle] = useState<Article[]>([]);
	const [page, setPage] = useState<number>(1);
	const [loadling, setLoading] = useState<boolean>(false);
	const [rowCount, setRowCout] = useState<number>(0);
	const classes = useStyles();
	const [search, setSearch] = useState<string>("");
	const [publish, setPublish] = useState<PublishStatus>(PublishStatus.all);
	const [author, setAuthor] = useState<any>(null);

	const rows = useMemo(() => articles.map((e, i) => {
		const publishDate = new Date(e.data.publish_date as string).getTime();
		const now = new Date().getTime();
		return {
			index: i,
			id: e.data.slug,
			type: e.type,
			slug: e.data.slug,
			title: e.data.title,
			theme:  e.data.theme ? e.data.theme.name : "",
			action: e.data.slug,
			publish_status: publishDate === 0 || publishDate > now ? 'Non publié' : 'Publié'
		}
	}), [articles]);
	
	const loadArticle = () => {
		const params: any = {
			_limit: pageSize,
			_start: (page - 1) * pageSize,
			_where : {
				slug_nin: props.execpt_slug ? props.execpt_slug : []
			},
			[props.collection_name === "all" ? "contributor" : "authors.slug"]: author?.slug,
			[props.collection_name === "all" ? "search" : "title_contains"]: search,
			_sort: "created_at:DESC",
			...props.params,
		}

		if (publish !== PublishStatus.all) {
			if (props.collection_name === "all") {
				params.publish = (publish === PublishStatus.pubished); 
			} else {
				if (publish === PublishStatus.pubished) {
					params["publish_date_gt"] = Date.now();
				} else {
					params["_where"]["_or"] = {
						publish_date_gt: Date.now(),
						publish_date_null: true,
					}
				}
			}
		}
		setLoading(true);
		const base_url = props.collection_name === "all" ? "all_admin" : props.collection_name;
		Strapi.get(base_url + "/count?" + qs.stringify(params)).then((r) => {
			setRowCout(r);
		})
		Strapi.get(base_url + "?" + qs.stringify(params), {
		}).then((r) => {
			setArticle(r);
			setLoading(false);
		});
	}
	if (props.update) {
		props.update.current = loadArticle;
	}
	useEffect(() => {
		loadArticle();
	}, [page, props.collection_name]);

	const columns: ColDef[] = [
		{ field: 'type', headerName: "Type", width: 130},
		{ field: 'title', headerName: 'Titre', width: 300, renderCell: (params: CellParams) => {
			const article = articles[params.data.index];
			return <a className={classes.article_link} href={`${settings.frontUrl}article/${article.type}/${article.data.slug}`}>
				{article.data.title}
			</a>
		}},
		{ field: 'theme', headerName: 'Theme', width: 130 },
		{ field: 'publish_status', headerName: 'Statut', width: 200},
		{
			field: 'action', headerName: 'Actions', width: 600, renderCell: (params: CellParams) => {
				return props.action(articles[params.data.index]);
			}
		}
	];
	return (
		<div>
			<Card className={classes.card}>
				<Grid container justifyContent="space-between" spacing={2}>
					<Grid item xs={6}>
						<TextField
							className={classes.search}
							variant="outlined"
							label="Rechercher des articles"
							value={search}
							onChange={(e) => setSearch(e.target.value)}
							onKeyPress={e => {
								if (e.key === 'Enter')
									loadArticle()
							}}
						/>
					</Grid>
					<Grid item xs={1}>
						<Select defaultValue={PublishStatus.all} onChange={e => setPublish(e.target.value as PublishStatus)} className={classes.publish} variant="outlined">
							<MenuItem key={PublishStatus.all} value={PublishStatus.all}>Tous</MenuItem>
							<MenuItem key={PublishStatus.pubished} value={PublishStatus.pubished}>Publié</MenuItem>
							<MenuItem key={PublishStatus.notpublished} value={PublishStatus.notpublished}>Non Publié</MenuItem>
						</Select>
					</Grid>
					<Grid item xs={5}>
						<AuthorsSearch value={author} onChange={setAuthor} variant={"outlined"} single/>
					</Grid>
				</Grid>
				<Button
					className={classes.addUser}
					onClick={() => loadArticle()}
				>
					Rechercher
				</Button>
			</Card>
			<XGrid
				pagination
				rows={rows}
				rowCount={rowCount}
				pageSize={pageSize}
				columns={columns}
				paginationMode="server"
				loading={loadling}
				onPageChange={(params) => {
					setPage(params.page)
				}}
				autoHeight
			/>
		</div>
	);
}

export default ArticleList;